import type { SiteConfig } from '../../@types/context/site-config.types';

export const organisationAxoSeConfig: Pick<SiteConfig, 'organisation'> = {
  organisation: {
    name: 'Axo Finans AB',
    number: '556907-5673',
    address: {
      streetAddress: 'c/o 7A, Norra Stationsgatan 69',
      addressLocality: 'Stockholm',
      postalCode: '113 64',
      addressCountry: 'SE',
    },
  },
};
